import React from "react";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  ResourceDescriptionContainer,
  ResourceDownloadItemContainer,
  ResourcesLanguageContainer,
  ResourcesReportImage,
  ResourcesSingleFrameContainter,
} from "./Resources.styles";

interface ResourceDownloadLink {
  externalLink?: boolean;
  isDownload?: boolean;
  label: string;
  link: string;
  linkInNewWindow?: boolean;
  onClick?: () => void;
}

interface ResourceDownloadItemProps {
  alt: string;
  contentType?: string;
  icon: string;
  links: ResourceDownloadLink[];
  title: React.ReactNode;
}

export const ResourceDownloadItem = ({
  alt,
  contentType = "(PDF)",
  icon,
  links,
  title,
}: ResourceDownloadItemProps): React.ReactElement => (
  <ResourceDownloadItemContainer role="listitem">
    <ResourcesReportImage src={icon} alt={alt} />
    <ResourcesSingleFrameContainter>
      <ResourceDescriptionContainer>
        {GetTypographyContent({
          content: title,
          isBold: true,
          size: "large",
          textColor: "greyMedium",
        })}
        {GetTypographyContent({
          content: contentType,
          size: "small",
          textColor: "greyMedium",
          padding: "4px 0 0 0",
        })}
      </ResourceDescriptionContainer>
      <ResourcesLanguageContainer>
        {links.map((link, index) => (
          <React.Fragment key={link.label}>
            {index > 0 && <div>&#124;</div>}
            {GetTypographyContent({
              content: link.label,
              size: "large",
              textColor: "redMedium",
              link: link.link,
              linkInNewWindow: link.linkInNewWindow,
              isDownload: link.isDownload,
              externalLink: link.externalLink,
              onClick: link.onClick,
            })}
          </React.Fragment>
        ))}
      </ResourcesLanguageContainer>
    </ResourcesSingleFrameContainter>
  </ResourceDownloadItemContainer>
);
